/* eslint-disable tailwindcss/no-custom-classname */
import { useRouter } from 'next/router'
import { useState } from 'react'
import { Modal } from '@/components/modal/Modal'
import { initialStyles } from '@/components/modal/Modal'
import { getSummaryPermission } from '@/api/summary'
import { SILVER_MAX_BOOK_COUNT } from '@/utils/constant'
import { ReadMoreSilverOverLimit } from './ReadMoreSilverOverLimit'

const modalStyle = {
  ...initialStyles,
  content: {
    ...initialStyles.content,
    textAlign: 'center',
  },
}

interface Props {
  readThisMonth: number
  summaryId: number
}
export const ReadMoreSilver: React.FC<Props> = ({
  readThisMonth,
  summaryId,
}) => {
  if (readThisMonth >= SILVER_MAX_BOOK_COUNT) {
    return <ReadMoreSilverOverLimit />
  }

  const router = useRouter()
  const [modalOpen, setModalOpen] = useState(false)

  /**
   * シルバーでの閲覧申請
   */
  const onClick = async () => {
    const res = await getSummaryPermission(summaryId)
    if (res.result) {
      // 要約データを再取得する
      router.reload()
    } else {
      // エラーモーダル表示
      setModalOpen(true)
    }
  }

  return (
    <>
      <Modal
        open={modalOpen}
        onRequestClose={() => setModalOpen(false)}
        style={modalStyle}
      >
        <div className="p-4">
          <div className="pb-8">閲覧要求に失敗しました</div>
          <button
            onClick={() => setModalOpen(false)}
            className="py-2 px-3 text-sm text-white bg-fl-blue rounded"
          >
            閉じる
          </button>
        </div>
      </Modal>
      <img
        src={`${process.env.IMG_SERVER}/common/readmore.png`}
        alt="もっと見る"
        className="mt-[-160px] w-full h-[160px] align-middle border-none"
      />
      <div className="p-[2px]">
        <div className="p-5 border border-[#fd8637] border-solid">
          <div className="text-[17px]">
            <div>
              <img
                src={`${process.env.IMG_SERVER}/common/logo.png`}
                alt="flierロゴ"
                className="align-middle border-none"
              />
              この要約を読みたいですか？
            </div>
            <div className="pt-5 text-justify">
              シルバープランでは
              <span className="text-[17px] text-justify text-[#fd8637]">
                毎月{SILVER_MAX_BOOK_COUNT}冊まで
              </span>
              閲覧可能です。
              <br />
              今月は
              <span className="text-[17px] text-justify text-[#fd8637]">
                {readThisMonth}冊
              </span>
              を閲覧しています。以下のいずれかをご選択ください。
            </div>
            <div className="pt-5 text-center">
              <button
                className="inline-block relative before:absolute before:top-[calc(50%-3px)] before:left-[10px] py-0 px-[30px] mb-0 before:w-[7px] h-[50px] before:h-[7px] text-sm font-normal leading-snug text-center text-white align-middle whitespace-nowrap bg-[#92949b] hover:bg-[#5e616e] rounded-[4px] border-b-2 before:border-b-2 before:border-l-2 border-[#5e616e] before:border-white border-solid before:border-solid before:rotate-45 cursor-pointer before:content-['']"
                onClick={() => router.push('/')}
              >
                トップページへ
              </button>
              <button
                className="inline-block relative after:absolute after:top-[calc(50%-3px)] after:right-[10px] py-0 px-[30px] mb-0 ml-[5px] after:w-[7px] h-[50px] after:h-[7px] text-sm font-normal leading-snug text-center text-white align-middle whitespace-nowrap bg-[#293c6f] hover:bg-[#0d1733] rounded-[4px] after:border-r-2 border-b-2 after:border-b-2 border-[#0d1733] after:border-white border-solid after:border-solid after:rotate-[-45deg] cursor-pointer after:content-['']"
                onClick={onClick}
              >
                この要約を読む
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
